import CustomHookFactory from "./CustomHookFactory";

export default CustomHookFactory("Snackbar", {
  isOpen: false,
  message: "",
  type: "success",
  autoHideDuration: 3000,
});
